import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { LAST_SEARCHES, MY_LOCATION, SEARCH_ON_MAP } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Stop } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/stop.interface';

@Component({
    selector: 'app-stations-auto-complete-feed',
    templateUrl: './stations-auto-complete-feed.component.html',
    styleUrls: ['./stations-auto-complete-feed.component.scss'],
    standalone: false
})
export class StationsAutoCompleteFeedComponent implements OnInit {
  @Output() onLastSearchClick = new EventEmitter<Stop>();
  @Output() onMapClick = new EventEmitter<void>();
  @Output() onCurrentLocationClick = new EventEmitter<void>();

  @Input() favoriteStations: any;
  @Input() displayCurrentLocation: boolean;
  @Input() isCurrentLocationLoading: boolean = false;

  myLocationText: string
  searchOnMapText: string
  lastSearchsText: string

  constructor(private readonly languageService: LanguageService) { }

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.myLocationText = MY_LOCATION[language.language]
      this.searchOnMapText = SEARCH_ON_MAP[language.language]
      this.lastSearchsText = LAST_SEARCHES[language.language]
    })
  }
}
